import { createApi } from 'swag-client-common/libs/rapi';
const baseUrl = '/api/v1/reseller';
export const ResellerApi = createApi({
  submitForm: {
    method: 'post',
    url: `${baseUrl}/submit`
  }
});